import { ReadonlyURLSearchParams } from "next/navigation";
import { getFacetAttributeName } from "./getFacetAttributeName";

/**
 * Transforms URL search params by mapping facet keys based on index
 * Uses existing getFacetAttributeName for consistent mapping
 *
 * Returns both the mapped params array and URLSearchParams,
 * along with a flag indicating if any changes were made
 */
export function getMappedSearchParams(
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  indexName: string,
): {
  paramsArray: Array<[string, string]>;
  urlParams: URLSearchParams;
  hasChanges: boolean;
} {
  const paramsArray: Array<[string, string]> = [];
  const urlParams = new URLSearchParams();
  let hasChanges = false;

  searchParams.forEach((value: string, key: string) => {
    const mappedKey = getFacetAttributeName(key, { indexName });

    if (mappedKey !== key) {
      hasChanges = true;
    }

    paramsArray.push([mappedKey, value]);
    urlParams.append(mappedKey, value);
  });

  return { paramsArray, urlParams, hasChanges };
}
